import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export function Hero() {
  const { t } = useLanguage();

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">

      {/* Background */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: 'url("https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99")',
            backgroundColor: '#1E293B',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/60 to-primary/20" />
      </div>

      {/* Content */}
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">

        {/* Tag */}
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-sm font-medium px-4 py-2 rounded-full mb-8">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          {t('hero.tag')}
        </div>

        {/* Title */}
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 leading-tight">
          {t('hero.title1')}
        </h1>
        <h2 className="text-5xl md:text-7xl font-bold mb-8 leading-tight bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
          {t('hero.title2')}
        </h2>

        {/* Subtitle */}
        <p className="text-xl text-blue-100/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          {t('hero.subtitle')}
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <a
            href="#get-started"
            className="inline-block bg-primary hover:bg-primary-dark text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-primary/30"
          >
            {t('hero.cta.primary')}
          </a>
          <a
            href="#projects"
            className="inline-block bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold px-8 py-4 rounded-lg transition-all duration-300"
          >
            {t('hero.cta.secondary')}
          </a>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 max-w-xl mx-auto mb-10">
          {[
            { num: t('hero.stat1.number'), label: t('hero.stat1.label') },
            { num: t('hero.stat2.number'), label: t('hero.stat2.label') },
            { num: t('hero.stat3.number'), label: t('hero.stat3.label') },
          ].map((s, i) => (
            <div key={i} className="text-center border border-white/10 rounded-xl py-4 px-2 bg-white/5 backdrop-blur-sm">
              <div className="text-3xl font-bold text-primary mb-1">{s.num}</div>
              <div className="text-xs text-white/70 leading-snug">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Industries */}
        <p className="text-xs text-white/50 tracking-wide">
          {t('hero.industries')}
        </p>

      </div>
    </div>
  );
}